import React from 'react'

interface InsightsProps {
  dateRange: [string | undefined, string | undefined]
  setDateRange: (date: [string | undefined, string | undefined]) => void
  trainingIds: number[]
  setTrainingIds: (trainingIds: number[]) => void
  trainingClassesIds: number[]
  setTrainingClassesIds: (trainingIds: number[]) => void
  teamIds: number[]
  setTeamIds: (teamIds: number[]) => void
}

const store = React.createContext<InsightsProps>({} as InsightsProps)
export const Provider = store.Provider

export const useFilters = () => React.useContext(store)
